/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Blank, CheckBox, Div, EvButton, Font, Form, Img, Input, Radio, Span } from "../../../styles/commonStyle";
import {
  AgreeAllBox,
  ChargingResultBox,
  ColorCircle,
  ContentBox,
  Layout,
  StipulationBox,
  StipulationContentBox,
  StipulationHeaderBox,
} from "../style";
import { PromoBox, PromoIllustration } from "./style";
import TenantHeader from "./header";
import bgImage from "../../../assets/images/img-bg-full-apply.jpg";
import evWherePromoImage from "../../../assets/images/evwhere-promo.jpg";
import { FieldError, FieldErrorsImpl, FieldValues, Merge, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { QRChargingValidation } from "../../../validation";
import { greenColor, inputBorderColor, lightBlueColor, modalGreyBtnColor, noticeRedColor, primaryColor } from "../../../styles/theme";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  findChargerQrTenantSelector,
  smartroTenantSelector,
  stipulationNonMemberPolicySelector,
  stipulationQR1Selector,
  stipulationQR2Selector,
} from "../../../recoil/variableAtom";
import expandLess from "../../../assets/images/expand_less.svg";
import expandMore from "../../../assets/images/expand_more.svg";
import { Stipulation } from "../../../model/stipulation";
import { RESULT, ResponseModel } from "../../../model/response";
import { isIOS, isMacOs, isMobile } from "react-device-detect";
import { GetSmartroDate, makeHyphenInput, makeMoid, makePayEncryptData } from "../../../util";
import useFetch from "../../../hooks/useFetch";
import usePost from "../../../hooks/usePost";
import Loading from "../../../components/loading/loading";
import { smartroTenantState } from "../../../recoil/atoms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

// GET /api/v1/qr/evcloud2/{tenant_slug}/{qr_code} 응답(Evcloud2QrShowRes) - 기존 Charger 모델과 필드가 다름
interface TenantCharger {
  tenant_id: string;
  charger_id: string;
  charger_code?: string | null;
  connector_id: number;
  nm?: string | null;
  price?: string | null;
  sttus?: string | null;
  availability_type?: string | null;
  connected: boolean;
}

function QRTenantPaymentPage() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(QRChargingValidation),
    mode: "onSubmit",
    reValidateMode: "onBlur",
  });
  const defaultKwhPay = "20000";
  const [kwhPay, setKwhPay] = useState(defaultKwhPay);
  const { tenantCode, qrcode } = useParams();
  let navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [isPaymentDisabled, setIsPaymentDisabled] = useState(true);
  const [getCharger, setCharger] = useState<TenantCharger>();
  const [isOpenStipulation, setOpenStipulation] = useState([false, false, false]);
  const [stipulationAgree, setStipulationAgree] = useState(false);
  const [stipulationDataList, setStipulationDataList] = useState<Array<string>>([]);
  const [isPhoneInfoOpen, setPhoneInfoOpen] = useState(false);
  const [isKwhPayInfoOpen, setKwhPayInfoOpen] = useState(false);
  const stipulationHeaderList = [
    "(필수) 이브이플러그(evPlug) 서비스 이용약관에 동의합니다.",
    "(필수) 전자금융거래 이용약관에 동의합니다.",
    "(필수) 개인정보 수집 및 이용에 동의합니다.",
  ];
  const [BuyerTel, setPhone] = useState("");
  const [VatAmt, setVatAmt] = useState(Math.floor(Number(defaultKwhPay) - Number(defaultKwhPay) / 1.1));
  const [TaxAmt, setTaxAmt] = useState(Number(defaultKwhPay) - Math.floor(Number(defaultKwhPay) - Number(defaultKwhPay) / 1.1));
  const moid = makeMoid();
  const mid = process.env.REACT_APP_SMARTRO_QR_MID;
  const edidate = GetSmartroDate(true);
  const [searchParams] = useSearchParams();
  const smartro_pay_result = searchParams.get("result");
  const location = useLocation();
  const state = location.state as any;
  const [getQuery, setQuery] = useState<any>();
  const [getSmartroQuery, setSmartroQuery] = useState<any>();
  const evWhereAppStoreUrl = "https://itunes.apple.com/kr/app/evwhere/id1231333404";
  const evWherePlayStoreUrl = "https://play.google.com/store/apps/details?id=com.ecoevc.evwhere.evwhere";

  const resSt1: ResponseModel<Stipulation> = useFetch({
    recoilSelector: stipulationNonMemberPolicySelector,
  });
  const resSt2: ResponseModel<Stipulation> = useFetch({
    recoilSelector: stipulationQR1Selector,
  });
  const resSt3: ResponseModel<Stipulation> = useFetch({
    recoilSelector: stipulationQR2Selector,
  });
  const getChargerData: ResponseModel<TenantCharger> = useFetch({
    recoilSelector: findChargerQrTenantSelector,
    query: getQuery,
  });
  const getSmartro: ResponseModel<any> = usePost({
    recoilSelector: smartroTenantSelector,
    data: getSmartroQuery,
    recoilState: smartroTenantState,
  });

  const redirectToEvWhereStore = () => {
    if (isIOS || isMacOs) {
      window.open(evWhereAppStoreUrl, "_blank");
    } else {
      window.open(evWherePlayStoreUrl, "_blank");
    }
  };

  useEffect(() => {
    if (resSt1?.result === RESULT.FAIL || resSt2?.result === RESULT.FAIL || resSt3?.result === RESULT.FAIL) {
      alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
    } else if (resSt1?.result === RESULT.OK && resSt2?.result === RESULT.OK && resSt3?.result === RESULT.OK) {
      setStipulationDataList([resSt1.data?.cn!, resSt2.data?.cn!, resSt3.data?.cn!]);
    }
  }, [resSt1, resSt2, resSt3]);

  const settingOpenStipulationCheck = (index: number) => {
    if (index === 0) {
      setOpenStipulation([!isOpenStipulation[0], isOpenStipulation[1], isOpenStipulation[2]]);
    } else if (index === 1) {
      setOpenStipulation([isOpenStipulation[0], !isOpenStipulation[1], isOpenStipulation[2]]);
    } else if (index === 2) {
      setOpenStipulation([isOpenStipulation[0], isOpenStipulation[1], !isOpenStipulation[2]]);
    }
  };

  const onSubmit = (data: FieldValues) => {
    setPhone(data.phone);
    onQrpaySubmit(data.phone);
  };

  const onQrpaySubmit = (phone: string) => {
    if (!stipulationAgree) {
      alert("결제 진행을 위해 약관에 동의가 필요합니다.");
    } else {
      const smartroId = "smartro-script";
      if (document.getElementById(smartroId) == null) {
        const script = document.createElement("script");
        script.src = isMobile
          ? `${process.env.REACT_APP_SMARTRO_QR_MOBILE}${GetSmartroDate(false)}`
          : `${process.env.REACT_APP_SMARTRO_QR_WEB}${GetSmartroDate(false)}`;
        script.id = smartroId;
        script.onload = () => {
          goPay(phone);
        };
        document.head.appendChild(script);
      } else {
        goPay(phone);
      }
    }
  };

  function goPay(phone: string) {
    // QR 결제는 REACT_APP_SMARTRO_QR_MID와 마찬가지로 항상 REAL 스크립트/모드를 사용
    const mode = "REAL";
    //@ts-ignore
    const smartropay = window.smartropay;
    smartropay.init({ mode: mode });
    let data;
    if (isMobile) {
      data = { FormId: "tranMgr" };
    } else {
      data = {
        FormId: "tranMgr",
        Callback: function (res: any) {
          const phoneNumNonDash = phone.replaceAll("-", "");
          //@ts-ignore
          var approvalForm: any = document.approvalForm;
          approvalForm.Tid.value = res.Tid;
          approvalForm.TrAuthKey.value = res.TrAuthKey;
          if (!document.getElementById("qrcode")) {
            let phoneInput = document.createElement("input");
            let qrCodeInput = document.createElement("input");
            phoneInput.setAttribute("type", "hidden");
            qrCodeInput.setAttribute("type", "hidden");
            phoneInput.setAttribute("id", "phone");
            qrCodeInput.setAttribute("id", "qrcode");
            phoneInput.setAttribute("name", "phone");
            qrCodeInput.setAttribute("name", "qrcode");
            approvalForm.appendChild(phoneInput);
            approvalForm.appendChild(qrCodeInput);
            approvalForm.phone.value = phoneNumNonDash;
            approvalForm.qrcode.value = qrcode;
          }
          approvalForm.action = `${process.env.REACT_APP_API_URL}/api/v1/qr/evcloud2/${tenantCode}/smartroPaycard/${qrcode}/${phoneNumNonDash}`;
          approvalForm.submit();
        },
      };
    }
    smartropay.payment(data);
  }

  const onChangeKwhPayHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const eventKwhPay = event.target.value;
    setKwhPay(eventKwhPay);
    let tmp = Number(eventKwhPay) / 1.1;
    let vat = Math.floor(Number(eventKwhPay) - tmp);
    let tax = Number(eventKwhPay) - vat;
    setVatAmt(vat);
    setTaxAmt(tax);
  };

  // 스마트로 결제창에서 돌아올 때 백엔드가 ?result=<json>으로 Tid/TrAuthKey/phone을 실어줌 - state로 옮겨서 쿼리 제거
  useEffect(() => {
    if (smartro_pay_result) {
      let json_smartro_result = JSON.parse(smartro_pay_result);
      json_smartro_result["TrAuthKey"] = encodeURIComponent(JSON.parse(searchParams.get("result")!)["TrAuthKey"])
        .toString()
        .replaceAll("%3D", "=")
        .replaceAll("%2B", "+")
        .replaceAll("%2F", "/")
        .replaceAll("%20", "+");

      navigate(`/QRtenant/${tenantCode}/${qrcode}`, {
        replace: true,
        state: {
          Tid: `${json_smartro_result["Tid"]}`,
          TrAuthKey: `${json_smartro_result["TrAuthKey"]}`,
          phone: `${json_smartro_result["phone"]}`,
        },
      });
    }
  }, [smartro_pay_result]);

  // 결제창 복귀 직후엔 새로고침으로 getCharger가 아직 비어있을 수 있어, tenant_id/charger_id가 채워질 때까지 대기 후 결제 확정 요청
  useEffect(() => {
    if (state && state.Tid && state.TrAuthKey && state.phone && getCharger?.tenant_id && getCharger?.charger_id) {
      setLoading(true);
      setSmartroQuery({
        Tid: state.Tid,
        TrAuthKey: state.TrAuthKey,
        phone: state.phone,
        tenant_id: getCharger.tenant_id,
        charger_id: getCharger.charger_id,
        charger_code: getCharger.charger_code ?? qrcode,
        connector_id: getCharger.connector_id,
        tenant_slug: tenantCode,
        qr_code: qrcode,
      });
    }
  }, [state, getCharger]);

  useEffect(() => {
    if (getSmartro?.result === RESULT.OK) {
      setLoading(false);
      navigate(`/QRtenant/${tenantCode}/${qrcode}/payment_result`, { replace: true, state: { Payment: true } });
    }
    if (getSmartro?.result === RESULT.FAIL) {
      alert(getSmartro.msg ?? "비회원 충전이 실패하였습니다.");
      setLoading(false);
      navigate(`/QRtenant/${tenantCode}/${qrcode}`, { replace: true });
    }
  }, [getSmartro]);

  useEffect(() => {
    setQuery({
      tenantCode: tenantCode,
      qrcode: qrcode,
    });
  }, []);

  useEffect(() => {
    if (getChargerData?.result === RESULT.OK) {
      const chargerData = getChargerData.data;
      setCharger(chargerData);
      setIsPaymentDisabled(!(chargerData?.sttus === "AVAILABLE" && chargerData?.availability_type === "OPERATIVE"));
    }
    if (getChargerData?.result === RESULT.FAIL) {
      alert(getChargerData.msg);
      navigate(`/QRtenant/${tenantCode}`);
    }
  }, [getChargerData]);

  const ready_div = (
    <Div className="w-full flex items-center">
      <ColorCircle color={greenColor} />
      <Blank width="0.5rem"></Blank>
      <Font fontWeight="500" fontSize="0.875rem">
        사용가능
      </Font>
    </Div>
  );
  const no_div = (
    <Div className="w-full flex items-center">
      <Font color={noticeRedColor} fontWeight="500" fontSize="0.875rem">
        현재 사용할 수 없는 충전기입니다.
      </Font>
    </Div>
  );

  let phoneError: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined = errors.phone ? errors.phone.message : undefined;
  let kwhPayError: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined = errors.kwhPay ? errors.kwhPay.message : undefined;

  return (
    <Div>
      <TenantHeader />
      {/* 스마트로 hidden form */}
      <form id="tranMgr" name="tranMgr" method="post">
        <input type="hidden" name="PayMethod" value="CARD" placeholder="" />
        <input type="hidden" name="GoodsCnt" maxLength={2} value="1" placeholder="" />
        <input type="hidden" name="GoodsName" maxLength={40} value="evPlug 비회원 결제" placeholder="" />
        <input type="hidden" name="Amt" maxLength={12} value={kwhPay} placeholder="" />
        <input type="hidden" name="Moid" maxLength={40} value={moid} placeholder="특수문자 포함 불가" />
        <input type="hidden" name="Mid" maxLength={10} value={mid} placeholder="" />
        <input type="hidden" name="BuyerName" maxLength={30} value="" placeholder="" />
        <input type="hidden" name="BuyerTel" maxLength={30} value={BuyerTel} placeholder="" />
        <input type="hidden" name="BuyerEmail" maxLength={30} value="" placeholder="" />
        <input
          type="hidden"
          name="StopUrl"
          size={100}
          className="input"
          value={`${process.env.REACT_APP_API_URL}/api/v1/qr/evcloud2/${tenantCode}/stop/${qrcode}`}
          placeholder="Mobile 연동 시 필수"
        />
        <input
          type="hidden"
          name="ReturnUrl"
          size={100}
          className="input"
          value={`${process.env.REACT_APP_API_URL}/api/v1/qr/evcloud2/${tenantCode}/smartroPaycard/${qrcode}/${BuyerTel.replaceAll("-", "")}`}
        />
        <input type="hidden" name="MallIp" maxLength={20} value="10.0.0.1" placeholder="" />
        <input type="hidden" name="EncryptData" value={makePayEncryptData(edidate, kwhPay)} placeholder="위/변조방지 HASH 데이터" />
        <input type="hidden" name="GoodsCl" value="0" placeholder="가맹점 설정에 따라 0 또는 1, 핸드폰결제 시 필수" />
        <input type="hidden" name="EdiDate" maxLength={14} value={edidate} placeholder="" />
        <input type="hidden" name="TaxAmt" maxLength={12} value={TaxAmt} placeholder="부가세 직접계산 가맹점 필수,숫자만 가능, 문장부호 제외" />
        <input type="hidden" name="TaxFreeAmt" maxLength={12} value="0" placeholder="부가세 직접계산 가맹점 필수,숫자만 가능, 문장부호 제외" />
        <input type="hidden" name="VatAmt" maxLength={12} value={VatAmt} placeholder="부가세 직접계산 가맹점 필수,숫자만 가능, 문장부호 제외" />
      </form>
      {!isMobile && (
        <form id="approvalForm" name="approvalForm" method="post">
          <input type="hidden" id="Tid" name="Tid" />
          <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
        </form>
      )}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Layout image={bgImage} paddingTop="0.5rem">
          <ContentBox paddingLeft="1.5rem" paddingRight="1.5rem">
            <Font fontSize="1.25rem" fontWeight="600">
              비회원 QR 결제
            </Font>
            <PromoBox className="mt-[1rem]">
              <PromoIllustration src={evWherePromoImage} alt="evWhere" />
              <Font fontSize="1rem" fontWeight="600" className="text-center">
                evWhere 앱으로 할인된 요금으로 더 편하게 충전하세요
              </Font>
              <Font fontSize="0.8rem" color={modalGreyBtnColor} fontWeight="500" className="text-center mt-[0.375rem] mb-[1rem]">
                회원 가입, 충전이력 조회, 간편결제까지 한 번에
              </Font>
              <EvButton
                width="100%"
                color="#ffffff"
                hoverColor="#ffffff"
                bgColor={primaryColor}
                type="button"
                onClick={redirectToEvWhereStore}
              >
                <FontAwesomeIcon icon={faDownload} style={{ marginRight: "0.5rem" }} />
                evWhere 다운로드하기
              </EvButton>
            </PromoBox>
            <Div className="w-full mb-[0.2rem] mt-[0.625rem] flex flex-col gap-[0.25rem] border border-gray-300 rounded-md p-[1rem] bg-white">
              {getCharger?.sttus === "AVAILABLE" ? ready_div : no_div}
              <Div className="flex flex-row">
                <Font fontWeight="500" fontSize="0.875rem" className=" w-[40%] flex-shrink-0">
                  큐알코드 번호
                </Font>
                <Font fontWeight="500" fontSize="0.875rem" className=" flex-shrink-1">
                  {getCharger?.charger_code ?? qrcode}
                </Font>
              </Div>
              <Div className="flex flex-row">
                <Font fontWeight="500" fontSize="0.875rem" className=" w-[40%] flex-shrink-0">
                  충전소명
                </Font>
                <Font fontWeight="500" fontSize="0.875rem" className=" flex-shrink-1">
                  {getCharger?.nm}
                </Font>
              </Div>
              <Div className="flex flex-row items-center">
                <Div className="flex flex-row flex-1">
                  <Font fontWeight="500" fontSize="0.875rem" className=" w-[40%] flex-shrink-0">
                    요금
                  </Font>
                  <Font fontWeight="500" fontSize="0.875rem" className=" flex-shrink-1">
                    {getCharger?.price}원/kWh
                  </Font>
                </Div>
              </Div>
            </Div>
            <Font className="w-full flex items-center mt-[1.25rem] mb-[0.375rem] cursor-pointer" fontWeight="500" onClick={() => setPhoneInfoOpen(!isPhoneInfoOpen)}>
              <Span color={noticeRedColor} style={{ marginRight: "0.25rem" }}>(필수)</Span>휴대폰 번호를 입력해주세요
              <Img width="24px" src={isPhoneInfoOpen ? expandLess : expandMore}></Img>
            </Font>
            {isPhoneInfoOpen && (
              <Font fontSize="calc(0.6rem + 0.2vw)" color={modalGreyBtnColor} className="w-full mb-[0.5rem]" fontWeight="500">
                휴대전화 번호는 본인 확인과 충전 알림 발송에 사용되며, 정확하지 않을 경우 알림 수신에 제한이 있을 수 있습니다.
              </Font>
            )}
            <Input
              type="text"
              className="w-full h-[2.5rem]"
              fontSize="0.875rem"
              placeholderFontSize="0.875rem"
              borderRadius="0.375rem"
              placeholder="ex>010-1234-5678"
              {...register!("phone")}
              name="phone"
              isError={phoneError ? true : false}
              onChange={(e: any) => setValue("phone", makeHyphenInput(e, "phone"))}
            />
            <Font color={noticeRedColor} className="w-full mt-[0.25rem]" fontSize="calc(0.7rem + 0.2vw)">
              {phoneError?.toString()}
            </Font>
            <Font className="w-full mt-[1.25rem] mb-[0.375rem] flex items-center cursor-pointer" fontWeight="500" onClick={() => setKwhPayInfoOpen(!isKwhPayInfoOpen)}>
              <Span color={noticeRedColor} style={{ marginRight: "0.25rem" }}>(필수)</Span>충전 요금을 선택해 주세요
              <Img width="24px" src={isKwhPayInfoOpen ? expandLess : expandMore}></Img>
            </Font>
            {isKwhPayInfoOpen && (
              <>
                <Font fontSize="calc(0.6rem + 0.2vw)" color={modalGreyBtnColor} className="w-full" fontWeight="500">
                  실제 충전량 만큼만 결제되며, 남은 금액은 자동으로 환불됩니다.
                </Font>
                <Font fontSize="calc(0.6rem + 0.2vw)" color={modalGreyBtnColor} className="w-full mb-[0.5rem]" fontWeight="500">
                  다만, 환불 완료까지는 카드사에 따라 소요 기간이 달라질 수 있습니다.
                </Font>
              </>
            )}
            <Div className="w-full flex flex-row gap-[0.5rem]">
              <Div className="flex flex-col w-full justify-center">
                {["10,000", "20,000", "30,000"].map((value, index, array) => (
                  <label key={"kwhPayLabel" + value}>
                    <Div className={`flex items-center ${index !== array.length - 1 ? "mb-[0.5rem]" : ""}`} key={"kwhPay" + value}>
                      <Radio
                        type="radio"
                        value={[10000, 20000, 30000][index]}
                        {...register!("kwhPay")}
                        name="kwhPay"
                        defaultChecked={value === "20,000" ? true : false}
                        onChange={(e) => onChangeKwhPayHandler(e)}
                      />
                      <Blank width="4px" />
                      <Font fontSize="16px" fontWeight="500" className="whitespace-nowrap">
                        {value}
                      </Font>
                      <Blank width="16px" />
                    </Div>
                  </label>
                ))}
                <Font color={noticeRedColor} className="w-full" fontSize="calc(0.7rem + 0.2vw)">
                  {kwhPayError?.toString()}
                </Font>
              </Div>
              <ChargingResultBox style={{ justifyContent: "center" }}>
                <Font fontWeight="500" color={lightBlueColor} fontSize="0.9rem">
                  예상 충전량
                </Font>
                <Font fontWeight="500" fontSize="1.25rem">{(Number.parseFloat(kwhPay) / parseFloat(`${getCharger?.price}`)).toFixed(2)} kWh</Font>
              </ChargingResultBox>
            </Div>
            <Blank height="1rem" />
            <label className="w-full">
              <AgreeAllBox className="mt-[0.3rem] mb-[0.5rem]" style={{ fontSize: "0.875rem" }}>
                <CheckBox
                  type="checkbox"
                  className="me-[8px] flex-shrink-0"
                  onChange={() => setStipulationAgree(!stipulationAgree)}
                  checked={stipulationAgree}
                />
                모두 동의합니다
              </AgreeAllBox>
            </label>
            <div className="border border-gray-300 rounded-md">
              {stipulationHeaderList.map((value, index, array) => (
                <StipulationBox
                  key={"charging_stpList" + index}
                  border={"none"}
                  borderRadius={index !== array.length - 1 ? "0" : "7px"}
                  style={{ paddingLeft: "0.25rem", margin: 0, borderBottom: index !== array.length - 1 ? `1px solid ${inputBorderColor}` : "none" }}
                >
                  <StipulationHeaderBox onClick={() => settingOpenStipulationCheck(index)}>
                    <Div className="flex">
                      <label className="flex">
                        <Font fontSize="12px" fontWeight="500">
                          {stipulationHeaderList[index]}
                        </Font>
                      </label>
                    </Div>
                    <Img width="24px" src={isOpenStipulation[index] ? expandLess : expandMore}></Img>
                  </StipulationHeaderBox>
                  <StipulationContentBox
                    height={isOpenStipulation[index] ? "150px" : "0px"}
                    className="scrollBar"
                    dangerouslySetInnerHTML={{ __html: stipulationDataList[index] }}
                  ></StipulationContentBox>
                </StipulationBox>
              ))}
            </div>
            <Div className="flex justify-between w-[100%] mt-[1.5rem]">
              <EvButton width="100%" color={"#ffffff"} hoverColor={"#ffffff"} bgColor={primaryColor} type="submit" disabled={isPaymentDisabled}>결제하기</EvButton>
            </Div>
          </ContentBox>
        </Layout>
      </Form>
      <Loading isLoading={isLoading} />
    </Div>
  );
}

export default QRTenantPaymentPage;
